<template>
    <div class="midblock width100"
         >
        <div style="position: relative">
            <img
                :src="cabinType.sample.img_url"
                class="width100"
                style="margin-bottom: 16px !important; border-radius:5px 5px 0 0;max-height:140px;"
            />
          <div v-if="discountaction && lowestRateForCabinType(cabinType.text) &&  lowestRateForCabinType(cabinType.text).apiData
                                .prijs > 1500" class="discountbox">
            Tijdelijk &euro; 100,- korting*
          </div>
        </div>

        <div class="padding20 textcenter">
            <span class="font16 bold">{{ cabinType.text }}</span><br>
          <span class="font12">{{ cabinType.omschrijving }}</span>
            <span
                v-if="lowestRateForCabinType(cabinType.text)"
                class="width100 marginbottom10"
            >
                <h3 class="darkblue bold" style="font-weight: normal" v-if="lowestRateForCabinType(cabinType.text).apiData
                                .prijs_cached">
                    <small>vanaf</small>
                    €
                    {{
                        roundPrice(
                            lowestRateForCabinType(cabinType.text).apiData
                                .prijs_cached / payload.cabins[0].volwassenen
                        )
                    }}
                    <small v-if="payload.cabins[0].volwassenen > 1">p.p.*</small>
                </h3>
              <h3 class="darkblue bold" style="font-weight: normal" v-else>
                    <small>vanaf</small>
                    €
                    {{
                        roundPrice(
                            lowestRateForCabinType(cabinType.text).apiData
                                .prijs / payload.cabins[0].volwassenen
                        )
                    }}
                    <small v-if="payload.cabins[0].volwassenen > 1">p.p.</small>
                </h3>

                <button
                    type="button"
                    class="btn btn-success btn-addon width100 font14 bold floatleft"
                    :id="'testCabinType' + cabinType.text"
                >
                    Selecteer <font-awesome-icon icon="angle-right" />
                </button>

                                <img v-if="euroaanbetaling || campaignaction"  src="https://cdn.cruisereizen.nl/tijdelijk.png" style="width:80px; padding-top:10px;">


            </span>
            <div v-if="!availabilityReceived || ajaxCalls > 0">
                <font-awesome-icon icon="spinner" :spin="true" /> Bezig met
                ophalen...
            </div>
            <div v-else-if="!lowestRateForCabinType(cabinType.text)">
                Geen {{ cabinType.text }} beschikbaar...
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CabinTypeSelect',
    props: {
        cabinType: Object,
        hutIndex: Number,
        cruise: Object,
        payload: Object,
        ajaxCalls: Number,
        availabilityReceived: Boolean,
        lowestRateForCabinType: Function,
        roundPrice: Function,
        euroaanbetaling: Boolean,
      discountaction: Boolean,
      campaignaction: Boolean,
    },
}
</script>
<style lang="scss">
.mostsold {
  position:relative;
  &:after {
    position:absolute;
    left:0;
    top:10px;
    padding-inline:10px;
    padding-block:3px;
    font-weight: bold;
    background: #f39c13;
    color: #fff;
    z-index:100;
    content: 'Meest gekozen';
  }
}
.soldout {
  pointer-events:none;
  filter: grayscale(80%);
  opacity: 0.6;
  position: relative;
  &:after {
    position:absolute;
    left:0;
    top:10px;
    padding-inline:10px;
    padding-block:3px;
    background: #2178b3;
    color: #fff;
z-index:100;
    content: 'Uitverkocht';
  }
}

.discountbox {
   position:absolute;
   left:-1px;
   top:10px;
   padding-inline:8px;
   padding-block:3px;
   font-weight: bold;
   background: green;
   color: #fff;
   z-index:100;
  font-size:11px;
 }

.isdiscount.mostsold {
  &:after {
    top: 40px;
  }
}
</style>
